var _style, _g, _path, _path2, _path3, _path4, _g2, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMybatis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1A1A1A;}\n\t.st1{fill:url(#path3057-6_1_);}\n\t.st2{fill:url(#path3055_1_);}\n\t.st3{fill:url(#path3057_1_);}\n\t.st4{fill:#D40000;}\n\t.st5{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "mybatis"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path3014_1_",
    className: "st0",
    d: "M85.7,41.7c6.2,1.8,6.2,1.8,6.2,1.8l-5.8,1.7l4,1.7l-4.2,0.8L85.7,41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1,48.7l-0.1-3l-1.4-0.6l1.4-0.4l-0.1-4.1l10.2,3l-6.3,1.9l4.4,1.8L85.1,48.7z M86.7,46.5l0,0.2l0.3-0.1L86.7,46.5z  M86.6,42.9l0,1.3l2.2-0.6L86.6,42.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path3057-6_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.4418,
    y1: 680.1855,
    x2: 298.5859,
    y2: 680.1855,
    gradientTransform: "matrix(1.8 0 0 -1.8 -473.8963 1269.0127)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D5656"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path3057-6",
    className: "st1",
    d: "M27.3,30.2c-0.8,10.6,11.9,27.6,24.5,29c4.9,0.5,12.1-4.1,11.7-9 C62.5,36.4,41.3,35.7,27.3,30.2L27.3,30.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path3055_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.1693,
    y1: 672.5473,
    x2: 357.1335,
    y2: 703.683,
    gradientTransform: "matrix(1.7978 -8.922389e-02 -8.922389e-02 -1.7978 -465.905 1312.9073)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D5656"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path3055",
    className: "st2",
    d: "M5,69.5c13.8,15.3,38.6,22.3,56.6,14.8c15-6.2,24.8-26.2,24.8-42c0-10.9-10.9-23.2-27-18.1 c-7.2,2.3-12.7,9.5-17.4,16.1C31.6,54.1,22.4,63.5,5,69.5L5,69.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path3057_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.4759,
    y1: 675.3591,
    x2: 292.955,
    y2: 681.7938,
    gradientTransform: "matrix(1.8 0 0 -1.8 -473.8963 1269.0127)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D5656"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path3057",
    className: "st3",
    d: "M15.4,38.5c0.9,10.6,16.2,25.4,28.8,24.7c4.9-0.3,11.3-6,10.1-10.8C51.1,39,30,41.7,15.4,38.5 L15.4,38.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path3038",
    className: "st4",
    d: "M50.3,30.1c4.4,0.4,12.1,1.8,18.2,2.2c5,0.3,10.9,0.2,15,0.1c3,5.1,3.4,9,2.5,15.4 c-8.8,1.5-15.4,0.3-22.6-2c-6.5-2.1-13-5.2-17.7-10.5C47.8,32.3,48.5,31.7,50.3,30.1L50.3,30.1z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g3044",
    transform: "matrix(0.86579468,0.3649666,-0.26391158,0.69231919,85.48741,-162.41002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3016",
    transform: "matrix(2,0,0,2.2452831,-561.08547,-140.09006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3012",
    className: "st5",
    d: "M318.1,176.7c0,1.5-1.3,2.6-3,2.6c-1.7,0-3-1.2-3-2.6s1.3-2.6,3-2.6 C316.7,174,318.1,175.2,318.1,176.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3797",
    className: "st0",
    d: "M317.9,176.6c0,1.1-0.9,2-2.1,2s-2.1-0.9-2.1-2s0.9-2,2.1-2 C316.9,174.6,317.9,175.5,317.9,176.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3801",
    className: "st5",
    d: "M317,175.5c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7S317,175.2,317,175.5z"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path3043",
    className: "st0",
    d: "M82.4,39.4c-1.1-0.7-2-1.6-3.1-2.3c-1.1-0.7-2.1-1.4-3.3-1.9c-0.5-0.2-1-0.4-1.6-0.5 c-0.4,0.1,0.1-0.2,0.1-0.3c0.4-0.4,0.7-0.8,1.1-1.2c0.5,0.1,0.9,0.3,1.3,0.4c1.2,0.5,2.3,1.2,3.4,2c1.1,0.7,2.1,1.6,3.2,2.3 c0.3,0.1,0.3,0.3,0.1,0.4C83.3,38.6,82.8,39,82.4,39.4L82.4,39.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path3095",
    className: "st4",
    d: "M51.2,36c-2.1-0.1-4.6,0.2-6.2-1.8c-1.4-1.6-2.6-3.5-3.3-5.6c-0.1-1.5-0.1-3.4-1.5-4.1 c-1.6-1-3.5-0.9-5.3-1.2c-3.3-0.2-6.5,1.2-9.6,2.4c-1.5,0.6-3.3,0.5-4.4-1c-0.8-1-1.4-2.2-1.9-3.4c-0.8-0.8-0.8-2,0.2-2.3 c0.6-0.4,1.3-0.9,1.9-1.3c1,2.2,1.8,4.9,3.9,5.9c2.2,0.5,4.2-0.9,6.2-1.5c2.9-1.1,6-1.3,8.9-0.7c1.7,0.2,3.8,0.9,4.3,3.1 c0.2,1.9,0.5,3.8,1.6,5.2c1.1,1.9,2.7,3.8,4.8,3.9c0.7,0.3,3-0.3,2.7,0.4C52.7,34.6,51.9,35.3,51.2,36L51.2,36z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path3097",
    className: "st4",
    d: "M49.8,35c-1.5-1-3.4-1.9-4.1-3.7c-0.4-1.2-0.9-2.5-1.1-3.8c-0.2-1.7,0-3.5-0.1-5.3 c0.3-1.1-0.4-2.1-1.6-2.4c-1.5-0.4-3-0.4-4.5-0.6c-1.4-0.1-3,0.2-4.1-0.8c-0.8-1-1.2-2.3-1.6-3.5c-0.1-0.6,0.7-0.7,1.1-1 c0.7-0.4,1.3-0.8,2-1.3c0.1,1.2,0.7,2.3,1.1,3.3c0.6,1.1,2,1.2,3.2,1.2c1.8,0.1,3.6,0.1,5.4,0.5c1.1,0.3,2.4,1,2.3,2.3 c0.1,2.7-0.4,5.4,0.6,8c0.4,1.2,0.8,2.4,1.8,3.2c0.8,0.7,1.7,1.2,2.6,1.7c-0.7,0.6-1.6,1.1-2.4,1.6C50.1,34.7,49.9,34.8,49.8,35 L49.8,35z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMybatis);
export default __webpack_public_path__ + "static/media/mybatis.19a1910752aca9e49c7a65bd488f6d1c.svg";
export { ForwardRef as ReactComponent };